<!-- Fix bug when AG-129 is solved, https://www.ag-grid.com/ag-grid-pipeline/ -->
<template>
  <div>
    <i
      v-if="status.code === 'true'"
      class="fas fa-check success"
      aria-hidden="true"
    />
    <i
      v-else-if="status.code === 'false'"
      class="fas fa-times tertiary-color"
      aria-hidden="true"
    />
  </div>
</template>

<script>

export default {
    name: 'CommonCheckIcon',
    props: {
        status: { type: Object, required: true }
    }
}

</script>
